import { useContext } from 'react';
import { Box, Grid } from '@mui/material';
import BlockData from '../../../models/BlockData';
import BlockProps from '../../../models/BlockProps';
import Utils from '../../../utils/Utils';
import BlockCenteredImageData from './BlockCenteredImageData';
import LinkButton from '../../Buttons/LinkButton';
import BlockComponentButton from '../../../models/BlockComponentValues/BlockComponentButton';
import ImageModal from '../../Modals/ImageModal/ImageModal';
import ImageComponent from '../../ImageComponent';
import { ImagesContext } from '../../../contexts/ImagesContext';
import CloseButton from '../../Buttons/Close';
import EditableText from '../../Form/EditableText';

export interface BlockCenteredImageProps extends BlockProps {
  blockData: BlockData[]
}

const BlockCenteredImage = ({
  data, isEditing, isTemplate, editHandler, blockData,
}: BlockCenteredImageProps) => {
  const props = (data.data as BlockCenteredImageData);
  const { images } = useContext(ImagesContext);
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <Grid
        container
        direction="column"
        alignItems="center"
        justifyContent="center"
        sx={{
          padding: 1.5,
          overflow: 'hidden',
          maxWidth: '50%',
          width: '50%',
        }}
      >

        {props.title.value && (
          <Grid item sx={Utils.hoverBorder(isEditing)}>
            <CloseButton
              show={isEditing}
              updateHandler={() => {
                props.title.value = undefined;
                editHandler(data.id, props);
              }}
            />
            <EditableText
              text={props.title.value}
              isEditable={isEditing && !isTemplate}
              updateHandler={(text) => {
                props.title.value = text;
                editHandler(data.id, props);
              }}
            />
          </Grid>
        )}

        {props.image.value !== undefined && (
          <Grid item sx={[Utils.hoverBorder(isEditing), { marginTop: 2 }]}>
            <CloseButton
              show={isEditing}
              updateHandler={() => {
                props.image.value = undefined;
                editHandler(data.id, props);
              }}
            />
            <ImageModal
              disabled={isTemplate || !isEditing}
              images={images}
              handleOnConfirm={(url: string) => {
                props.image.value = url;
                editHandler(data.id, props);
              }}
            >
              <ImageComponent src={props.image.value} />
            </ImageModal>
          </Grid>
        )}

        {props.text.value && (
          <Grid item sx={[Utils.hoverBorder(isEditing), { marginTop: 2 }]}>
            <CloseButton
              show={isEditing}
              updateHandler={() => {
                props.text.value = undefined;
                editHandler(data.id, props);
              }}
            />
            <EditableText
              text={props.text.value}
              isEditable={isEditing && !isTemplate}
              updateHandler={(text) => {
                props.text.value = text;
                editHandler(data.id, props);
              }}
            />
          </Grid>
        )}

        {props.button && (
          <Grid item sx={[Utils.hoverBorder(isEditing), { height: '100%', width: '100%', marginTop: 2 }]}>
            <CloseButton
              show={isEditing}
              updateHandler={() => {
                props.button = undefined;
                editHandler(data.id, props);
              }}
            />
            <LinkButton
              button={props.button}
              isEditable={isEditing && !isTemplate}
              isTemplate={isTemplate}
              updateHandler={(button?: BlockComponentButton) => {
                props.button = button;
                editHandler(data.id, props);
              }}
              blockData={blockData}
            />
          </Grid>
        )}

      </Grid>
    </Box>
  );
};

export default BlockCenteredImage;
